/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */

import { Box, SxProps } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { TextFieldProps } from '@mui/material/TextField'
import { TimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs, { Dayjs } from 'dayjs'

type MUTimePickerProps = {
  dateTime: Dayjs | null
  onDateTimeChange: (date: dayjs.Dayjs | null) => void
  label: string
  variant?: TextFieldProps['variant']
  textProps?: TextFieldProps
  open?: boolean
  error?: boolean
  helperText?: string
  sx?: SxProps<Theme>
  hidden?: boolean
  clearable?: boolean
}
export const MUITimePicker = (props: MUTimePickerProps) => {
  const {
    dateTime,
    onDateTimeChange,
    label,
    variant = 'outlined',
    textProps = {},
    open,
    error,
    helperText,
    sx,
    hidden,
    clearable = false,
  } = props

  if (hidden) return null
  const Body = (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        label={label}
        value={dateTime}
        open={open}
        onChange={newValue => {
          onDateTimeChange(newValue)
        }}
        slotProps={{
          ...(clearable
            ? {
                field: {
                  clearable: true,
                  onClear: () => onDateTimeChange(null),
                },
              }
            : {}),
          textField: {
            error: !!error,
            helperText,
            variant,
            fullWidth: true,
            ...textProps,
          },
        }}
        sx={{ color: 'red' }}
      />
    </LocalizationProvider>
  )
  if (sx) {
    return <Box sx={sx}>{Body}</Box>
  }
  return Body
}
